import BaseApi from "./BaseApi";

export default class Ticket extends BaseApi{
    construct() {}
    
    static async create(params){
        let url = Ticket.getFullApiUrl()

        return await Ticket.getAxiosInstance().post(url, params);
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/admin/ticket/";
    }

    static getFullApiUrl(){
        let domain = location.pathname.split('/')[1]
        return BaseApi.getFullDomainApiUrl() + "api/" + domain + "/admin/ticket/";
    }
}